import MHolidaySettingItem from './index.vue';

MHolidaySettingItem.install = app => {
  app.component(MHolidaySettingItem.name, MHolidaySettingItem);
};

export default MHolidaySettingItem;
